<template>
  <aside class="sidenav navbar navbar-vertical navbar-expand-xs border-0 fixed-left" style="background:white;box-shadow: 7px 0 60px rgb(0 0 0 / 5%);" id="sidenav-main">
    <!-- border-radius-xl my-3 #FAFBFC-->
    <div class="sidenav-header sidenav-header-border-bottom" style="background:#FFFFFF;height:3.45rem;">
      <i class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute right-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
      <a class="navbar-brand m-0" href="/" style="padding:0.8rem 1.50rem;">
        <img src="@/assets/img/ptpr_sidenav_bg.png" class="navbar-brand-img h-100" alt="...">
        <span class="ms-1 font-weight-bold pl-2">Pertamina Retail</span>
      </a>
    </div>

    <hr v-if="false" class="horizontal dark mt-0 mb-0">

    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main"  style="border-right: 1px solid #EAEDF8;">
      <ul class="navbar-nav" style="margin-left:0.0rem;padding-top:10px;padding-bottom:10px;">
        <template v-for="(parent,i) in this.listMenuSidebar">
          <li class="nav-item" :key="i" v-if="$store.getters.getLoginInfo.userroles.indexOf(parent.access + '_1') != -1">
            <b-link :class="'nav-link router-link '+ (i==0?'active':'')+' '+parent.path.split('/')[1]" :to="parent.path" v-if="!parent.hidden" @click="setNoChild(parent.path)" >
              <div class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
                <i :class="'icon_sidebar_menu '+parent.icon+''"></i>
              </div>
              <span class="nav-link-text ms-1">{{parent.name}}</span>
              <button v-on:click.stop.prevent="buttonhrefstoplink" class="nav-button-arrow" v-if="parent.children" v-b-toggle="parent.id" style="margin-left: auto; border:0px;">
                <i class="fas fa-angle-down right"></i>
              </button>
            </b-link>
            <b-collapse class="nav" v-if="parent.children" :id="parent.id">
              <ul class="navbar-nav" style="width: 100%;">
                <li :class="'nav-item'" v-for="(children,z) in parent.children" :key="z">
                    <b-link :class="'nav-link router-link '" :to="children.path" @click="setNoChild2(children.path)" v-if="children.access == null || (children.access!=null && $store.getters.getLoginInfo.userroles.indexOf(children.access + '_1') != -1)">
                      <div style="width: 10px;"></div>
                      <div class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
                        <i :class="'icon_sidebar_menu far fa-circle'"></i>
                      </div>
                      <span class="nav-link-text ms-1">{{children.name}}</span>
                      <button v-on:click.stop.prevent="buttonhrefstoplink" class="nav-button-arrow" v-if="children.children" v-b-toggle="children.id" style="margin-left: auto; border:0px;">
                        <i class="fas fa-angle-down right"></i>
                      </button>
                    </b-link>

                    <!-- start sub menu level 3 -->
                    <b-collapse class="nav" v-if="children.children" :id="children.id">
                      <ul class="navbar-nav" style="width: 100%;">
                        <li :class="'nav-item'" v-for="(children2,z2) in children.children" :key="z2">
                            <b-link :class="'nav-link router-link '" :to="children2.path" @click="setNoChild2(children2.path)" v-if="children2.access == null || (children2.access!=null && $store.getters.getLoginInfo.userroles.indexOf(children2.access + '_1') != -1)">
                              <div style="width: 20px;"></div>
                              <div class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
                                <i :class="'icon_sidebar_menu far fa-dot-circle'"></i>
                              </div>
                              <span class="nav-link-text ms-1">{{children2.name}}</span>
                            </b-link>
                        </li>
                      </ul>
                    </b-collapse>
                    <!-- end sub menu level 3 -->

                </li>
              </ul>
            </b-collapse>
          </li>
        </template>
      </ul>


    </div>

  </aside>
</template>

<script>
import { nextTick } from 'vue';
import {listMenuSidebar} from '@/utility.js';

export default
{
    components:{
    },
    mounted() {
        const firstPath = window.location.pathname.split('/')[1];
        this.$store.commit('updatePageActive',firstPath);
        nextTick(() => {
            this.setNoChild(window.location.pathname);
        });

        //console.log('roles: ' + this.$store.getters.getLoginInfo.userroles);
        //console.log('roles index: ' + this.$store.getters.getLoginInfo.userroles.indexOf('MOD2023050007_1'));
    },
    methods:{
      setNoChild(parent){

        this.$store.commit('updatePageHadChild',0)
        const firstPath = window.location.pathname.split('/')[1];
        this.$store.commit('updatePageActive',firstPath);

        //document.querySelector('li.nav-item a').classList.remove('active');
        const navLink = document.querySelector('li.nav-item a');
        if (navLink) {
            navLink.classList.remove('active');
        }

        if(parent.split('/')[1] == this.$store.getters.pageActive) {
            /*
            if(parent.split('/')[1]=='')
            document.querySelector('li.nav-item a:first-child').classList.add('active');
            document.querySelector('li.nav-item a.'+parent.split('/')[1]).classList.add('active');
            */
            if (parent.split('/')[1] === '') {
                const firstChild = document.querySelector('li.nav-item a:first-child');
                if (firstChild)
                    firstChild.classList.add('active');
            }

            /*
            const specificNav = document.querySelector('li.nav-item a.' + parent.split('/')[1]);
            if (specificNav)
                specificNav.classList.add('active');
            */
            //Replace with below
            const allNavItems = document.querySelectorAll('li.nav-item a');
            allNavItems.forEach(item => {
                if (item.classList.contains(parent.split('/')[1])) {
                    item.classList.add('active');
                }
            });
        } else {
            //document.querySelector('li.nav-item a:first-child').classList.add('active');
            const firstChild = document.querySelector('li.nav-item a:first-child');
            if (firstChild)
                firstChild.classList.add('active');
        }
    },

    setNoChild2(parent){
        var currentUrl = window.location.pathname;
        //console.log('currentUrl: '+currentUrl);

        //console.log(parent.split('/')[1]+'==' +currentUrl.split('/')[1]);
        //this.$store.getters.pageActive
        document.querySelector('li.nav-item a:first-child').classList.remove('active')
        if(parent.split('/')[1]==currentUrl.split('/')[1])
        {
          document.querySelector('li.nav-item a.'+parent.split('/')[1]).classList.add('active')
          //console.log(parent.split('/')[1]);
        }else{
          // alert(parent)
          document.querySelector('li.nav-item a:first-child').classList.add('active')
          //console.log('first child');
        }

      },

      buttonhrefstoplink:(e)=>{
        e.preventDefault()
        e.stopPropagation()
      }
    },
    data(){
      return {listMenuSidebar:listMenuSidebar()}
    },
}

</script>
<style>


#sidenav-collapse-main {
  overflow:hidden;
  /*overflow-y:hidden;overflow-x:hidden;*/
}

#sidenav-collapse-main:hover {
  overflow-y:auto;
}

.sidenav-header-border-bottom {
  border-bottom: 1px solid #EAEDF8;
}

.icon_sidebar_menu{
  /*color:#555 !important; */
  color:#8590A5 !important;;
  font-size: 14px !important;
}

.active .icon_sidebar_menu {
  /*color:#fff !important; */
  color:#3f6ad8 !important;
}

.icon-sm i { top:1px !important;}

aside.loader {
  background:linear-gradient(-35deg,#c7251c 75%,transparent);
}

aside.loader hr.horizontal.dark {
  background-image: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));
}

.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    margin: 0.2rem 0.5rem !important;
}

aside.loader a.nav-link {
  color:#f1f1f1 !important;
}

.router-link-exact-active {
  color:#3f6ad8 !important;
  background: #e0f3ff;
  border-radius: 4px;
}

.li-nav-link-sub-a {
  position: relative;
  width: 100%;
  /* margin-right: 0px; */
  margin-left: 0px !important;
  padding-left: 4rem !important;
}

.ul-nav-sub {
  padding: 0px;
  list-style: none;
  width:100%;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem !important;
}

.li-nav-link-sub {
  padding-left:0rem;
  padding-right: 0rem;
  padding-top:0px;
  padding-bottom:0px;
  margin-top:1px;
  margin-bottom: 1px;
}


.nav-button-arrow {
  background: #e0f3ff;
  color:#3f6ad8;
  padding-top:2px;
  width:25px;
  border-radius: 4px;
}

.nav-button-arrow:hover {
  background: #3f6ad8;
  color:#Fff;
}

.navbar-vertical.navbar-expand-xs .navbar-collapse {
    height: calc(100vh - 70px) !important;
}
</style>
